import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'

let registered = false

/**
 * Registers GSAP plugins and recreates the easing curves used by the original
 * Webflow interactions so the conversion matches 1:1.
 *
 * - `wfEase`     -> CSS `ease`     cubic-bezier(0.25, 0.1, 0.25, 1)
 * - `wfOutQuad`  -> Webflow `outQuad` easeOutQuad
 * - `wfInOut`    -> CSS `ease-in-out` used by tab transitions
 *
 * Safe to call repeatedly and on the server (no-op until the browser exists).
 */
export const registerGsap = (): void => {
    if (registered || typeof window === 'undefined') return

    gsap.registerPlugin(ScrollTrigger, CustomEase)

    CustomEase.create('wfEase', '0.25, 0.1, 0.25, 1')
    CustomEase.create('wfOutQuad', '0.25, 0.46, 0.45, 0.94')
    CustomEase.create('wfInOut', '0.42, 0, 0.58, 1')

    registered = true
}

/** Honor the user's reduced-motion preference. */
export const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

/**
 * Small screens skip the continuous decorative loops (rotating gradient,
 * floating shapes) so the GPU isn't re-compositing/repainting every frame —
 * the main cause of slow loads and scroll jank on phones and tablets.
 */
export const isCompactViewport = (): boolean =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 991px)').matches

export { gsap, ScrollTrigger, CustomEase }
